<div *ngIf="allViews">
    <div class="clare-column-select">
        <mat-form-field>
            <select matNativeControl [(ngModel)]="activeViewId" (change)="changeProjectView()">
                <option *ngFor="let listItem of allViews; trackBy: trackById" [value]="listItem?.id">
                    {{ listItem?.name }}
                </option>
            </select>
        </mat-form-field>
    </div>
    <div class="actions" fxFlex="50px" fxLayoutAlign="end center">
        <button mat-button color="primary" class="href-btn" (click)="editProjectView()">Edit</button>
    </div>
</div>
